<template>
	<div class="login">
		<el-dialog :visible.sync="$store.state.user.loginShowFlag" width="400px" :before-close="handleClose"
			:close-on-press-escape="false" :close-on-click-modal="false">
			<template v-if="type == 'login'">
				<el-tabs v-model="activeIndex" @tab-click="handleClick">
					<el-tab-pane label="短信登录" name="1" style="font-size:18px;"></el-tab-pane>
					<el-tab-pane label="账号登录" name="2"></el-tab-pane>
				</el-tabs>
				<el-form ref="form" :model="form" :rules="rules" size="medium"
					style="    margin-top: 10px;margin-bottom: 15px;">
					<el-form-item prop="phonenumber" v-if="activeIndex == 1">
						<el-input v-model="form.phonenumber" placeholder="请输入手机号"></el-input>
					</el-form-item>
					<el-form-item prop="username" v-if="activeIndex == 2">
						<el-input v-model="form.username" placeholder="请输入用户名"></el-input>
					</el-form-item>
					<el-form-item prop="password" v-if="activeIndex == 2">
						<el-input v-model="form.password" type="password" placeholder="请输入登录密码（8位以上）"></el-input>
					</el-form-item>
					<el-form-item v-if="activeIndex == 1" prop="smsCode">
						<el-input v-model="form.smsCode" placeholder="请输入验证码" style="width:228px"></el-input>
						<el-button style="margin-left:20px;" @click="getSms" v-if="timeFlag"> {{ countDownText
							}}</el-button>
						<span v-else="!timeFLag" style="margin-left:20px">{{ countDownTime }}s后重新获取</span>
					</el-form-item>
					<el-form-item v-if="activeIndex == 2" prop="code">
						<div style="display: flex;">
							<el-input v-model="form.code" placeholder="请输入验证码" style="flex:1"></el-input>
							<el-image style="flex: 0 0 107px;margin-left: 15px;height: 36px;" :src="image"
								@click="getCaptcha"></el-image>
						</div>
					</el-form-item>
					<el-button size="medium" @click="submit"
						style="width: 100%; color:#fff; background-image: linear-gradient(to right, #5A0096, #3D1EE1);">登
						录</el-button>
					<div class="forgetPsd">
						<div class="font14" style="color: rgb(153, 153, 153);">
							{{ activeIndex == 1 ? '未注册手机号验证后将自动注册' : '设置密码后可用帐号登录(非会员卡密码)' }}
						</div>
						<div class="font14">
							<span class="commonTextColor point" @click="forgetPwd('forgetPwd')">忘记密码</span>
							<el-divider direction="vertical"></el-divider>
							<span class="commonTextColor point" @click="forgetPwd('register')">注册</span>
						</div>
					</div>
				</el-form>
			</template>
			<template v-if="type == 'register'">
				<div class="font24" style="margin-bottom: 15px;">快捷登录/注册</div>
				<el-form ref="form" :model="form" :rules="rules" size="medium" style="    margin-top: 10px;">
					<el-form-item prop="phonenumber">
						<el-input v-model="form.phonenumber" placeholder="请输入手机号"></el-input>
					</el-form-item>
					<el-form-item prop="smsCode">
						<el-input v-model="form.smsCode" placeholder="请输入验证码" style="width:228px"></el-input>
						<el-button style="margin-left:20px;" @click="getSms" v-if="timeFlag"> {{ countDownText
							}}</el-button>
						<span v-else="!timeFLag" style="margin-left:20px">{{ countDownTime }}s后重新获取</span>
					</el-form-item>
					<el-button size="medium" @click="submit"
						style="width: 100%; color:#fff; background-image: linear-gradient(to right, #5A0096, #3D1EE1);">立即登录</el-button>
					<div class="forgetPsd">
						<div></div>
						<div class="font14">
							<span style="color: #ccc;">已有账号？</span>
							<span class="commonTextColor point" @click="forgetPwd('login')">登录</span>
						</div>
					</div>
				</el-form>
			</template>
			<template v-if="type == 'forgetPwd'">
				<div class="font24" style="margin-bottom: 15px;">设置密码</div>
				<el-form ref="form" :model="form" :rules="rules" size="medium" style="    margin-top: 10px;">
					<el-form-item prop="phonenumber">
						<el-input v-model="form.phonenumber" placeholder="请输入手机号"></el-input>
					</el-form-item>
					<el-form-item prop="smsCode">
						<el-input v-model="form.smsCode" placeholder="请输入验证码" style="width:228px"></el-input>
						<el-button style="margin-left:20px;" @click="getSms" v-if="timeFlag"> {{ countDownText
							}}</el-button>
						<span v-else="!timeFLag" style="margin-left:20px">{{ countDownTime }}s后重新获取</span>
					</el-form-item>
					<el-form-item prop="phonenumber">
						<el-input v-model="form.phonenumber" placeholder="设置新密码(8位以上)"></el-input>
					</el-form-item>
					<el-button size="medium" @click="submit"
						style="width: 100%; color:#fff; background-image: linear-gradient(to right, #5A0096, #3D1EE1);">确定</el-button>
					<div class="forgetPsd">
						<div></div>
						<div class="font14">
							<span style="color: #ccc;">已有账号？</span>
							<span class="commonTextColor point" @click="forgetPwd('login')">登录</span>
						</div>
					</div>
				</el-form>
			</template>

		</el-dialog>
	</div>
</template>

<script>
import { login, captcha, userInfo, captchaSms, smsLogin, currentStudent } from "@/api/login"
export default {
	name: "login",
	data() {
		var validateUsername = (rule, value, callback) => {
			if (this.activeIndex == 2) {
				if (value === '') {
					callback(new Error('请输入用户名'));
				} else {
					callback();
				}
			} else {
				callback();
			}
		};
		var validatePhone = (rule, value, callback) => {
			if (this.activeIndex == 1) {
				if (value === '') {
					callback(new Error('请输入手机号'));
				} else {
					callback();
				}
			} else {
				callback();
			}
		};
		var validatePassword = (rule, value, callback) => {
			if (this.activeIndex == 2) {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					callback();
				}
			} else {
				callback();
			}
		};
		var validateSmsCode = (rule, value, callback) => {
			if (this.activeIndex == 1) {
				if (value === '') {
					callback(new Error('请输入验证码'));
				} else {
					callback();
				}
			} else {
				callback();
			}
		};
		var validateCode = (rule, value, callback) => {
			if (this.activeIndex == 2) {
				if (value === '') {
					callback(new Error('请输入验证码'));
				} else {
					callback();
				}
			} else {
				callback();
			}
		};
		return {
			activeIndex: "1",
			form: {
				smsCode: "",
				password: "",
				phonenumber: "",
				username: "",
				uuid: "",
				code: ""
			},
			type: 'register',
			countDownText: '获取验证码',
			timeFlag: true,
			countDownTime: 60,
			rules: {
				phonenumber: [
					{ validator: validatePhone, trigger: 'blur' },
				],
				password: [
					{ validator: validatePassword, trigger: 'blur' },
				],
				smsCode: [
					{ validator: validateSmsCode, trigger: 'blur' },
				],
				code: [{
					validator: validateCode, trigger: 'blur'

				}],
				username: [
					{ validator: validateUsername, trigger: 'blur' },
				]
			},
			image: ""
		}
	},
	created() {
		this.forgetPwd('login')
		this.getCaptcha();
	},
	methods: {
		forgetPwd(type) {
			this.type = type
			this.resetForm()
			this.getCaptcha()
		},
		resetForm() {
			this.activeIndex = "1"
			this.form = {
				smsCode: "",
				password: "",
				phonenumber: "",
				username: "",
				uuid: "",
				code: ""
			}
			this.countDownText = '获取验证码'
			this.timeFlag = true
			this.countDownTime = 60
		},
		handleClick(val) {
			this.$refs.form.resetFields();
		},
		handleClose() {
			this.forgetPwd('login')
			this.$refs.form.resetFields();
			this.$store.commit("UPDATE_LOGINSHOWFLAG", false)
		},
		async getCaptcha() {
			let res = await captcha();
			this.image = "data:image/gif;base64," + res.data.img
			this.form.uuid = res.data.uuid;
		},
		async getSms() {
			let res = await captchaSms(this.form.phonenumber);
			this.timer = setInterval(() => {
				let time = this.countDownTime;
				if (time > 0) {
					this.timeFlag = false;
					this.countDownTime = time - 1;
				} else {
					clearInterval(this.timer);
					this.countDownTime = 60;
					this.timeFlag = true;
				}
			}, 1000);

		},
		async submit() {
			let flag = await this.$refs.form.validate();
			if (this.activeIndex == 1) {
				if (flag) {
					let res = await smsLogin({
						smsCode: this.form.smsCode,
						phonenumber: this.form.phonenumber,
						uuid: ""
					})
					this.$store.commit("UPDATE_TOKEN", res.data.token)
					//获取用户信息
					let user = await currentStudent();
					this.$store.commit("UPDATE_STUDENT", user.data)
					this.$store.commit("UPDATE_LOGINSHOWFLAG", false)

					this.$store.commit("UPDATE_ISLOGINFLAG", true)
					if (!user.data.score) {
						this.$store.commit("UPDATE_UPDATEINFOFLAG", true)
					}
					this.forgetPwd('login')
				}
			} else {
				if (flag) {
					let res = await login(this.form)
					let token = res.data.token;
					this.$store.commit("UPDATE_TOKEN", token)
					this.$store.commit("UPDATE_LOGINSHOWFLAG", false)
					this.$store.commit("UPDATE_ISLOGINFLAG", true)
					let user = await currentStudent();
					this.$store.commit("UPDATE_STUDENT", user.data)
					this.$message.success("登录成功")
					if (!user.data.score) {
						this.$store.commit("UPDATE_UPDATEINFOFLAG", true)
					}
					let resp = await userInfo();
					this.forgetPwd('login')
				}
			}
			clearInterval(this.timer);
			this.countDownTime = 60;
			this.timeFlag = true;
		}
	}
}
</script>

<style lang="less">
.login {
	.forgetPsd {
		display: flex;
		margin-top: 20px;
		justify-content: space-between;
	}

	.el-tabs__item {
		font-size: 20px;
	}
}
</style>